import { type MouseEvent, useCallback, useRef } from "react";

export function usePrintIframe(src?: string, autocleanupTimeout = 1000) {
  const ref = useRef<HTMLIFrameElement>(undefined);

  const print = useCallback(
    async (srcOverride?: string) => {
      const srcToPrint = srcOverride || src;
      if (!srcToPrint) {
        return;
      }

      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      iframe.src = srcToPrint;

      try {
        document.body.appendChild(iframe);
        iframe.onload = () => {
          iframe.contentWindow?.focus();
          iframe.contentWindow?.print();
          iframe.contentWindow?.addEventListener("afterprint", () => {
            document.body.removeChild(iframe);
          });
        };
      } catch (e) {
        console.error(e);
      } finally {
        setTimeout(() => {
          if (iframe?.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }
        }, autocleanupTimeout);
      }
    },
    [src, autocleanupTimeout],
  );

  const onClick = useCallback(
    async (e?: MouseEvent) => {
      e?.preventDefault();
      e?.stopPropagation();
      await print();
    },
    [print],
  );

  return { onClick, print, ref };
}
